import { parse } from 'query-string';
import Cookies from 'universal-cookie';

import { IQueryParams } from 'typescriptDefs';

import { setCookieExpiration } from '.';
import { whitelistQueryParams } from './whitelistedParams';

export const appendCookieTrackingParams = (cookieName: string, params: IQueryParams) => {
  const cookies = new Cookies();
  const existing = cookies.get(cookieName) ?? { hash: {}, search: {} };
  const dateExpiry = setCookieExpiration(30);

  cookies.set(
    cookieName,
    {
      hash: { ...existing.hash, ...params.hash },
      search: { ...existing.search, ...params.search },
      dateSet: new Date(),
    },
    { expires: dateExpiry },
  );
};

export const setCookieTracking = (cookieName: string, defaultSearchParams: Record<string, string> = {}) => {
  let paramsFilteredHash: Record<string, string | string[] | null> = {};
  let paramsFilteredSearch: Record<string, string | string[] | null> = { ...defaultSearchParams };
  const cookies = new Cookies();

  if (window?.location?.hash) {
    const queryParamsHash = parse(window.location.hash);
    for (const param in queryParamsHash) {
      if (whitelistQueryParams.hash[param]) {
        paramsFilteredHash = {
          ...paramsFilteredHash,
          [param]: queryParamsHash[param],
        };
      }
    }
  }

  if (window?.location?.search) {
    const queryParamsSearch = parse(window.location.search);
    for (const param in queryParamsSearch) {
      if (whitelistQueryParams.search[param]) {
        paramsFilteredSearch = {
          ...paramsFilteredSearch,
          [param]: queryParamsSearch[param],
        };
      }
    }
  }

  if (Object.keys(paramsFilteredHash).length !== 0 || Object.keys(paramsFilteredSearch).length !== 0) {
    const dateExpiry = setCookieExpiration(30);
    cookies.set(
      cookieName,
      {
        hash: paramsFilteredHash,
        search: paramsFilteredSearch,
        dateSet: new Date(),
      },
      {
        expires: dateExpiry,
      },
    );
  }
};
